import React from 'react';
import { BookOpen, AlertCircle } from 'lucide-react';
export function WhatIsSection() {
  return <section className="py-16 px-4 bg-[#0a0a0a]" data-id="element-238">
      <div className="max-w-4xl mx-auto text-center" data-id="element-239">
        <h2 className="text-3xl md:text-5xl font-black text-white mb-12 uppercase" data-id="element-240">
          ¿Qué es el Mega Pack Pisos Epoxi Pro Desde Cero?
        </h2>

        <div className="grid md:grid-cols-2 gap-12 items-center text-left" data-id="element-241">
          <div className="space-y-6" data-id="element-242">
            <p className="text-xl text-gray-300 font-medium" data-id="element-243">
              Es un programa paso a paso que te enseña:
            </p>
            <ul className="space-y-4" data-id="element-244">
              {['Qué comprar', 'Cómo aplicar correctamente', 'Cómo evitar errores costosos', 'Cómo cotizar en Argentina', 'Cómo cerrar tu primer trabajo'].map((item, i) => <li key={i} className="flex items-start" data-id="element-245">
                  <div className="bg-amber-900/30 p-1 rounded-full mr-3 mt-1" data-id="element-246">
                    <div className="w-2 h-2 bg-amber-500 rounded-full" data-id="element-247"></div>
                  </div>
                  <span className="text-lg text-gray-200" data-id="element-248">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="bg-[#1a1a1a] text-white p-8 rounded-2xl shadow-xl border border-amber-900/30 transform rotate-1 hover:rotate-0 transition-transform duration-300" data-id="element-249">
            <div className="space-y-4 font-bold text-xl text-center" data-id="element-250">
              <p className="flex items-center justify-center gap-2" data-id="element-251">
                <AlertCircle className="text-red-500" data-id="element-252" /> Sin experiencia previa.
              </p>
              <div className="h-px bg-gray-700 w-1/2 mx-auto" data-id="element-253"></div>
              <p className="flex items-center justify-center gap-2" data-id="element-254">
                <AlertCircle className="text-red-500" data-id="element-255" /> Sin empresa.
              </p>
              <div className="h-px bg-gray-700 w-1/2 mx-auto" data-id="element-256"></div>
              <p className="flex items-center justify-center gap-2" data-id="element-257">
                <AlertCircle className="text-red-500" data-id="element-258" /> Sin improvisar.
              </p>
              <div className="mt-8 bg-amber-600 py-3 px-6 rounded-lg text-black uppercase tracking-wider shadow-lg font-black" data-id="element-259">
                Solo seguir el sistema
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}